import { Badge, BadgeColorVariant } from '@ui-components/neo.tax';

import { StyledTooltip } from './rd-projects-layout.styled';

export type RdProjectAIGuidanceCellProps = {
  colorVariant?: BadgeColorVariant;
  title?: string;
  children?: React.ReactNode;
};

export const RdProjectAIGuidanceCell = ({
  children,
  colorVariant,
  title,
}: RdProjectAIGuidanceCellProps): React.ReactElement => (
  <StyledTooltip
    text={title}
    options={{
      placement: 'bottom',
      showArrow: true,
    }}
  >
    <Badge colorVariant={colorVariant} dot={false}>
      {children}
    </Badge>
  </StyledTooltip>
);
